import {createMuiTheme} from '@material-ui/core/styles';

export const spacingUnit = 8;

import {
    GRANITE_1,
    GRANITE_2,
    GRANITE_3,
    GRANITE_6,
    GRANITE_7,
    SNOW_BLIND,
    SUMMER_2,
    SUMMER_3,
    SUMMER_4,
    CONIFER_2,
    CONIFER_3,
    CONIFER_4,
} from './colors';

// Include rules in here only if they're meant to apply website-wide.
// One-off changes should be implemented downstream.
export default createMuiTheme({
    palette: {
        primary: {
            dark: CONIFER_2,
            main: CONIFER_3,
            light: CONIFER_4,
        },
        secondary: {
            dark: SUMMER_2,
            main: SUMMER_3,
            light: SUMMER_4,
        },
        error: {
            dark: SUMMER_2,
            main: SUMMER_3,
            light: SUMMER_4,
        },
    },

    typography: {
        fontSize: 11,
        htmlFontSize: 10,
        fontFamily: ['Arimo', 'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif'],

        button: {
            textTransform: 'none',
        },

        h6: {
            fontWeight: 'bold',
            lineHeight: 'normal',
        },

        caption: {
            fontSize: 11,
            color: GRANITE_3,
        },

        body2: {
            lineHeight: 1.5,
        }
    },

    spacing: spacingUnit,

    props: {
        MuiButtonBase: {
            disableRipple: true,
        },

        MuiExpansionPanel: {
            elevation: 0
        },

        MuiMenu: {
            anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left'
            },
            getContentAnchorEl: null
        }
    },

    overrides: {

        MuiListSubheader: {
            root: {
                borderBottomColor: GRANITE_7,
                borderBottomStyle: 'solid',
                borderBottomWidth: 1,
                lineHeight: null,
                marginBottom: spacingUnit,
                paddingBottom: spacingUnit / 2,
                paddingTop: spacingUnit * 2,
            },

            gutters: {
                paddingLeft: 0,
                paddingRight: 0,
                marginLeft: spacingUnit * 2,
                marginRight: spacingUnit * 2,
            },

            sticky: {
                backgroundColor: SNOW_BLIND
            }
        },

        MuiButton: {
            root: {
                '&:active, &:focus, &:hover': {
                    outline: 'none',
                    textDecoration: 'none',
                }
            }
        },

        MuiAvatar: {
            root: {
                border: `1px solid ${GRANITE_7}`,
                borderRadius: spacingUnit
            }
        },

        MuiToolbar: {
            root: {
                width: '100%',
                maxWidth: 1170,
                margin: '0 auto'
            }
        },

        MuiTooltip: {
            tooltip: {
                fontSize: 12,
                backgroundColor: GRANITE_3,
            }
        },

        MuiMenuItem: {
            root: {
                color: GRANITE_2,
                textDecoration: 'none',
                fontSize: 14,
                '&:hover': {color: GRANITE_1},
                '&:focus': {
                    color: GRANITE_2,
                    outline: 0,
                    textDecoration: 'none'
                }
            }
        },

        MuiSwitch: {
            colorPrimary: {
                '&$checked': {
                    '& + $track': {
                        backgroundColor: '#7BF063',
                    },
                    '&$disabled': {
                        color: '#abdaa0',
                        '& + $track': {
                            color: '#abdaa0',
                        }
                    }
                },
                '&$disabled': {
                    color: GRANITE_6,
                    '& + $track': {
                        backgroundColor: GRANITE_6,
                    }
                }
            },
            track: {
                backgroundColor: GRANITE_6,
            },
        },
    }
});
